// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jU6VCXu9_14GpKiiPmvA {
  border: 1px solid black;
  border-collapse: collapse;
}`, "",{"version":3,"sources":["webpack://./js/view/component/legal-policy/styles.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,yBAAA;AACF","sourcesContent":[".borders {\n  border: 1px solid black;\n  border-collapse: collapse;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"borders": `jU6VCXu9_14GpKiiPmvA`
};
export default ___CSS_LOADER_EXPORT___;
